import AcWorkAudit from './src/main';

/* istanbul ignore next */
AcWorkAudit.install = function(Vue) {
  Vue.component(AcWorkAudit.name, AcWorkAudit);
};

export default AcWorkAudit;
